export function matchesSearchTerms(values: unknown, query: string | null | undefined): boolean {
  const terms = (query ?? '').trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) {
    return true;
  }

  const searchableText = flattenSearchValues(values).join(' ').toLowerCase();
  return terms.every((term) => searchableText.includes(term));
}

function flattenSearchValues(value: unknown): string[] {
  if (value === null || value === undefined) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.flatMap(flattenSearchValues);
  }
  if (value instanceof Date) {
    return [value.toLocaleDateString(), value.toISOString()];
  }
  if (typeof value === 'object') {
    return Object.values(value).flatMap(flattenSearchValues);
  }
  return [String(value)];
}
